'use client';

import {
  type PropsWithChildren,
  type ReactElement,
  useEffect,
  useState,
} from 'react';

type Props = PropsWithChildren;

export const useIsClient = (): boolean => {
  const [isClient, setIsClient] = useState<boolean>(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return isClient;
};

export const ClientOnly = ({ children }: Props): ReactElement | null => {
  const isClient = useIsClient();
  return isClient ? <>{children}</> : null;
};
